import { styled } from "@mui/system";
import TextField from "@mui/material/TextField";

const ArthaTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    fontSize: "12px",
    height: "32px", // Set the desired height
    padding: "4px", // Adjust padding if needed
  },
  "& .MuiInputBase-input": {
    padding: "6px 8px", // Adjust the padding inside the input field
    lineHeight: "1.2", // Adjust line height to control text spacing
    "&::placeholder": {
      fontSize: "16px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "14px",
  },
}));

export default ArthaTextField;
